import { render } from "./Iframepopup.vue?vue&type=template&id=7c6ec92b"
import script from "./Iframepopup.vue?vue&type=script&lang=js"
export * from "./Iframepopup.vue?vue&type=script&lang=js"

import "./Iframepopup.vue?vue&type=style&index=0&id=7c6ec92b&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__